export enum AssetPageObjectModel {
  AddMetadataButton = 'addMetadataButton',
  AddMetadataFieldName = 'addMetadataFieldName',
  AddMetadataFieldType = 'addMetadataFieldType',
  AddMetadataFieldValue = 'addMetadataFieldValue',
  AddToCompareButton = 'addToCompareButton',
  AddToCompareIcon = 'addToCompareIcon',
  AddToCompareMenu = 'addToCompareMenu',
  AssetActionRow = 'assetActionRow',
  DeleteAssetButton = 'deleteAssetButton',
  DownloadAssetButton = 'downloadAssetButton',
  FindMatchesButton = 'findMatchesButton',
  ReplaceAssetFileButton = 'replaceAssetFileButton',
  ReprocessAssetButton = 'reprocessAssetButton',
  ViewAssetButton = 'viewAssetButton',
  MissingDependenciesWarningIcon = 'missingDependenciesWarningIcon',
}
